export const Routes =  {
    root: '/sbs-v1',
    about: '/about', 
    nba: '/nba',
    dailyMatchups: '/daily-matchups',
    analytics: '/analytics',
    backtest: '/backtest',
    login: '/login'
};